import './ContentBuilderTemplate.scss';
import './ContentBuilderTemplate122.scss';

import React, { useEffect, useRef, useState } from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cn } from '../../../utils/bem';
import { cnContentBuilderTemplate } from './index';
import { IRoot122 } from './models/CTI_122.props';
import { Link } from 'react-scroll';

export const cnFloatingNav = cn('FloatingNav');

export const ContentBuilderTemplate: React.FC<IRoot122> = props => {
  const { type, contentId, links = [] } = usePropsHandler(
    cnContentBuilderTemplate(),
    props
  );

  const typeNumber = type.toString();

  /**
   when you render this builderItem you have to put topGap='0' and bottomGap='0' to avoid an extra paddings
   <ContentBuilderItem type={122} topGap='0' bottomGap='0' />
   */

  const [showContainer, setShowContainer] = useState(false);
  const isManualScroll = useRef(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const onScroll = () => {
      const scroll = window.scrollY;
      if (scroll > 96) {
        setShowContainer(true);
      } else {
        setShowContainer(false);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const [activeLink, setActiveLink] = useState('');
  const offset = window.innerWidth < 768 ? -80 : -120;

  const handleClick = (anchorLink: string) => {
    isManualScroll.current = true;
    setActiveLink(anchorLink);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      isManualScroll.current = false;
    }, 900);
  };

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <div className={cnFloatingNav({ visible: showContainer })}>
        <div className={cnFloatingNav('Inner')}>
          {links?.length > 0 &&
            links?.map(link => {
              const anchorLink = link?.link.includes('#')
                ? link.link.replace('#', '')
                : link.link;

              return (
                <Link
                  to={anchorLink}
                  className={cnFloatingNav('Link', {
                    active:
                      activeLink.toLowerCase().trim() ===
                      anchorLink.toLowerCase().trim(),
                  })}
                  onClick={() => handleClick(anchorLink)}
                  onSetActive={() => {
                    if (!isManualScroll.current) {
                      setActiveLink(anchorLink);
                    }
                  }}
                  spy
                  smooth={true}
                  offset={offset}
                  duration={800}
                >
                  {link.title}
                </Link>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ContentBuilderTemplate;
